import { Button, Grid } from "@mui/material";
import { useFormik } from "formik";
import Flex from "../../../../../../../components/Flex";
import Input from "../../../../../../../components/Input";
import StyledDialog from "../../../../../../../components/StyledDialog";
import { DisclosureHost } from "../../../../../../../hooks/use-disclosure";
import { RosTemplateType } from "../../../../../../../services";

interface PeAddModeDialogProps {
  disclosureHost: DisclosureHost;
  onSave: (v?: RosTemplateType) => Promise<any>;
}

/**
 * @author [Rajkumar Rathod]
 */
const PeAddModeDialog = ({ disclosureHost, onSave }: PeAddModeDialogProps) => {
  const formik = useFormik<RosTemplateType>({
    initialValues,
    onSubmit: (values) => {
      onSave(values).then(() => {
        disclosureHost.close();
        formik.resetForm();
      });
    },
  });

  return (
    <StyledDialog
      onClose={disclosureHost.close}
      open={disclosureHost.opened}
      dialogTitle={"Add More Physical Exam Template"}
      dialogAction={
        <Flex width={"100%"} justifyContent={"end"}>
          <Button onClick={formik.submitForm} variant="contained">
            Save & close
          </Button>
        </Flex>
      }
    >
      <Flex flexDirection={"column"} width={"44vw"} height={"10vh"}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Input
              label="Name"
              textFieldProps={{
                value: formik.values.name,
                onChange: formik.handleChange("name"),
                placeholder: "Enter Name",
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Input
              label="Description"
              textFieldProps={{
                value: formik.values.value,
                onChange: formik.handleChange("value"),
                placeholder: "Enter Description",
              }}
            />
          </Grid>
        </Grid>
      </Flex>
    </StyledDialog>
  );
};

export default PeAddModeDialog;

const initialValues = {
  name: "",
  value: "",
  isSelected: true,
  isBaseType: false,
};
